<ngx-spinner bdColor="rgba(0, 0, 0, 0.1)" [fullScreen]="true">
  <div class="custom-spinner">
    <img src="assets/img/spinner-otic-2018.png" alt="Logo Empresa" class="spinner-logo">
  </div>
</ngx-spinner>
  
<router-outlet></router-outlet>